import { DegenCollection } from './collections';

type DegenCollectionMapping = Record<
  DegenCollection,
  (nftsOwned: any, collectionConstMapping: any) => { collectionName: string; nftsOwned: any[]; baseSource: string }
>;

export interface IDegenCollectionsProps {
  nftsOwnedMiamiDegens: any[];
  nftsOwnedNYCDegens: any[];
  nftsOwnedSDGUStacksPunks: any[];
  nftsOwnedBitcoin: any[];
  onClickBack: () => void;
}
export const collectionMapping: DegenCollectionMapping = {
  Miami: (nftsOwned: any, collectionConstMapping: any) => ({
    collectionName: 'MiamiDegen',
    nftsOwned: nftsOwned,
    baseSource: collectionConstMapping['MiamiDegen'].baseSource,
  }),
  NYC: (nftsOwned: any, collectionConstMapping: any) => ({
    collectionName: 'NYCDegen',
    nftsOwned: nftsOwned,
    baseSource: collectionConstMapping['NYCDegen'].baseSource,
  }),
  SDGU: (nftsOwned: any, collectionConstMapping: any) => ({
    collectionName: 'SDGU StacksPunks',
    nftsOwned: nftsOwned,
    baseSource: collectionConstMapping['SDGU StacksPunks'].baseSource,
  }),
  Bitcoin: (nftsOwned: any, collectionConstMapping: any) => ({
    collectionName: 'BitcoinDegen',
    nftsOwned: nftsOwned,
    baseSource: collectionConstMapping['BitcoinDegen'].baseSource,
  }),
};
